import React from "react";
import { Container, Row, Col, Card, Button, ListGroup } from "react-bootstrap";
import { Link } from "react-router-dom";

const Pricing = () => {
  const plans = [
    {
      name: "DevOps & Cloud",
      price: "",
      duration: "4 Months",
      popular: true,
      features: [
        "Linux & Bash Scripting",
        "Git & GitHub",
        "Jenkins CI/CD",
        "Docker & Kubernetes",
        "AWS Cloud Services",
        "JFrog Artifactory",
        "SonarQube Code Quality",
        "Argo CD",
        "Terraform & Ansible",
        "Prometheus & Grafana",
        "Project-Based Learning",
        "Job Assistance"
      ],
      buttonText: "Enroll Now",
      buttonVariant: "primary"
    },
    {
      name: "Full-Stack MERN",
      price: "",
      duration: "4 Months",
      popular: false,
      features: [
        "HTML, CSS, JavaScript",
        "React.js Development",
        "Node.js & Express.js",
        "MongoDB & MySQL",
        "RESTful APIs",
        "Authentication & Security",
        "Deployment & Hosting",
        "Project-Based Learning",
        "Job Assistance"
      ],
      buttonText: "Enroll Now",
      buttonVariant: "outline-primary"
    },
    {
      name: "Automation Testing",
      price: "",
      duration: "3 Months",
      popular: false,
      features: [
        "Selenium & Playwright",
        "Manual to Automation Transition",
        "API Testing with Postman",
        "Cucumber BDD Frameworks",
        "Test Script Design & Maintenance",
        "CI/CD Automation Testing",
        "Real-Time Project Practice",
        "Interview Preparation"
      ],
      buttonText: "Enroll Now",
      buttonVariant: "outline-primary"
    }
  ];

  const additionalInfo = [
    {
      title: "Payment Methods",
      description: "We accept major credit/debit cards, UPI, netbanking, and bank transfers.",
    }
  ];

  return (
    <Container className="page-shell pricing-page my-5">
      <Row className="mb-5 page-header">
        <Col>
          <span className="eyebrow dark">Pricing</span>
          <h1 className="text-center mb-3 fw-bold">Pricing Plans</h1>
          <p className="page-subtitle text-center mx-auto">
            Choose the perfect plan for your career goals. All plans include 
            comprehensive training, projects, and job assistance.
          </p>
        </Col>
      </Row>

      {/* Pricing Cards - Alignment Fixed */}
      <Row className="g-4 mb-5 align-items-stretch justify-content-center">
        {plans.map((plan, index) => (
          <Col key={index} xs={12} md={6} lg={4}>
            <Card 
              className={`h-100 pricing-card ${plan.popular ? 'pricing-card-popular' : ''}`}
            >
              {plan.popular && (
                <div className="bg-primary text-white text-center py-2 fw-bold small">
                  MOST POPULAR
                </div>
              )}
              <Card.Body className="p-4 d-flex flex-column">
                <div className="text-center mb-4">
                  <h3 className="fw-bold">{plan.name}</h3>
                  <div className="my-3">
                    <span className="display-5 fw-bold text-primary">
                      {plan.price}
                    </span>
                  </div>
                  <p className="text-muted mb-0">{plan.duration}</p>
                </div>
                
                <ListGroup variant="flush" className="mb-4 flex-grow-1">
                  {plan.features.map((feature, idx) => (
                    <ListGroup.Item key={idx} className="px-0 border-0 d-flex align-items-start">
                      <span className="text-success me-2">✓</span>
                      {feature}
                    </ListGroup.Item>
                  ))}
                </ListGroup>

                <Button 
                  variant={plan.buttonVariant} 
                  className="w-100 py-3 fw-bold" 
                  size="lg"
                  as={Link}
                  to="/contact"
                >
                  {plan.buttonText}
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Additional Information Section */}
      <div className="py-5">
        <h2 className="text-center mb-4 fw-bold">Additional Information</h2>
        <Row className="g-4 justify-content-center">
          {additionalInfo.map((info, index) => (
            <Col key={index} xs={12} sm={10} md={6} lg={4}>
              <Card className="h-100 info-card border-0 text-center">
                <Card.Body className="p-4">
                  <h5 className="fw-bold text-primary">{info.title}</h5>
                  <Card.Text className="text-muted">
                    {info.description}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </div>

      <hr className="my-5 opacity-25" />

      {/* FAQ Section */}
      <div className="py-4">
        <h2 className="text-center mb-5 fw-bold">Frequently Asked Questions</h2>
        <Row className="g-4">
          <Col md={6}>
            <h5 className="fw-bold">Which course is best for me?</h5>
            <p className="text-muted">
              Choose the plan that matches your career goal. DevOps suits cloud and deployment roles, 
              Full-Stack is ideal for web development, and Automation Testing is best for QA and software quality roles.
            </p>
          </Col>
          <Col md={6}>
            <h5 className="fw-bold">Do you offer job support?</h5>
            <p className="text-muted">
              Yes. Every program includes practical learning, project exposure, and guided support to help 
              you prepare for interviews and job opportunities.
            </p>
          </Col>
          <Col md={6}>
            <h5 className="fw-bold">Are the training sessions practical?</h5>
            <p className="text-muted">
              Absolutely. Our courses focus on real-world projects, assignments, lab work, and hands-on 
              implementation so you can confidently apply what you learn.
            </p>
          </Col>
          <Col md={6}>
            <h5 className="fw-bold">What payment methods do you accept?</h5>
            <p className="text-muted">
              We accept major credit and debit cards, UPI, net banking, and bank transfers. EMI options may also be available based on your selected plan.
            </p>
          </Col>
        </Row>
      </div>

      {/* Call to Action Section */}
      <Card className="cta-panel border-0 text-white mt-5">
        <Card.Body className="p-5 text-center">
          <h3 className="mb-3 fw-bold">Have Questions About Pricing?</h3>
          <p className="lead mb-4" style={{ color: "rgba(255,255,255,0.9)" }}>
            Our team is here to help you choose the right plan for your needs. 
            Contact us for personalized assistance.
          </p>
          <Button as={Link} to="/contact" variant="light" size="lg" className="px-5 py-3 fw-bold text-primary">
            Contact Us
          </Button>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Pricing;